import { render, staticRenderFns } from "./ModalButtons.vue?vue&type=template&id=61537e22&"
import script from "./ModalButtons.ts?vue&type=script&lang=js&"
export * from "./ModalButtons.ts?vue&type=script&lang=js&"
import style0 from "./ModalButtons.vue?vue&type=style&index=0&id=61537e22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports